var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isShow)?_c('div',{ref:"flontPanelElement",staticClass:"float-panel",style:(_vm.setStyle),on:{"click":_vm.close}},[_c('div',{staticClass:"float-panel__main",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }